import React from "react";
import BoostIcon from "../boosts/BoostIcon";

const GameBoostBar = ({ entries = [], boostMessage = "", onActivate }) => {
    if (!entries.length) {
        return null;
    }

    return (
        <div className="gameBoostBar" aria-label="Run boosts">
            <div className="gameBoostBar__buttons">
                {entries.map((entry) => (
                    <button
                        key={entry.id}
                        type="button"
                        className={`gameBoostBar__button${
                            entry.armed ? " gameBoostBar__button--armed" : ""
                        }${entry.disabled ? " gameBoostBar__button--disabled" : ""}`}
                        onClick={() => onActivate(entry.id)}
                        disabled={entry.disabled}
                        title={
                            entry.disabled
                                ? entry.disabledReason
                                : entry.armed && entry.runKey !== "reveal"
                                  ? `${entry.name} active — tap again to cancel`
                                  : entry.armed
                                    ? `${entry.name} active — tap the glowing card`
                                    : `${entry.name} (${entry.count}) — ${entry.description}`
                        }
                        aria-label={`${entry.name}, ${entry.count} available${
                            entry.armed ? ", active" : ""
                        }`}
                    >
                        <BoostIcon
                            boost={entry}
                            className="gameBoostBar__icon"
                            size={28}
                        />
                        <span className="gameBoostBar__count">{entry.count}</span>
                    </button>
                ))}
            </div>
            {boostMessage ? (
                <div className="gameBoostBar__message" role="status">
                    {boostMessage}
                </div>
            ) : null}
        </div>
    );
};

export default GameBoostBar;
